module.exports = __webpack_public_path__ + "img/7.ed1ce0b1.jpg";